import { LoadingContainer } from 'peach/components'
import { useHistory, useParams } from 'peach/router'

import { DynamicForm, Page, PageHeader } from 'core/components'
import { useCreateWorkitemType } from 'core/types'
import { workflowItemTypeSchema } from 'core/utils/generated/formSchemas'

const CreateWorkflowItemType = () => {
  const history = useHistory()
  const { companyId } = useParams<{ companyId?: string }>()

  const { mutateAsync: createWorkitemType } = useCreateWorkitemType({
    companyId,
  })

  return (
    <LoadingContainer isLoading={false}>
      <Page variant='full'>
        <PageHeader title='Create Workflow Item Type' />
        <DynamicForm
          data={{}}
          fieldEditMode='all'
          onSubmit={async (payload: any) => {
            const res = await createWorkitemType(payload)
            const id = (res as any)?.data?.id as string | undefined
            if (id) {
              history.push(`/companies/${companyId}/workflow-item-types/${id}`)
            } else {
              history.push(`/companies/${companyId}/workflow-item-types`)
            }
          }}
          schema={workflowItemTypeSchema}
          submitText='Create'
          validationRules={{
            descriptionShort: [
              (v: unknown) =>
                (typeof v === 'string' && v.trim().length > 0) ||
                'descriptionShort is required',
            ],
          }}
        />
      </Page>
    </LoadingContainer>
  )
}

export default CreateWorkflowItemType
